import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../_services/essentials/store';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { Button } from "@mui/material";
import { ArrowForwardOutlined } from '@mui/icons-material';
import { TextField, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import useScreenSize from "../../../_components/UserScreenSize";

export { Login };

function Login() {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);
    const screenSize = useScreenSize();

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    // form validation rules 
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .email("Please enter a valid Email"),
        password: Yup.string().required('Password is required')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;

    function onSubmit({ email, password }) {
        return dispatch(authActions.login({ email, password }));
    }

    return (

        <Stack variant="outlined" sx={{
            pt: '20%',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {/*<SitemarkIcon />*/}
            <Stack
                sx={{
                    mb: 5
                }}
            >
                <img
                    src="../assets/images/healthcare/kyol_logo.png"
                    alt="KeyInsight Data Logo"
                    style={{ height: '106px', justifyContent: 'center' }}

                /></Stack>
            <Stack
                sx={{
                    // minWidth: '900px',
                    justifyContent: 'center', flexGrow: '1', gap: 1
                }}
            >
                <Typography
                    // component="h1"
                    variant="h1"
                    sx={{ fontWeight: '600', fontSize: '32px', textAlign:"center", mb: 2 }}
                >
                    Welcome to KeyInsight Data Hub
                </Typography>
            </Stack>
            <Stack>
                <Typography
                    // component="h1"
                    variant="h6"
                    sx={{ fontWeight: '500', fontSize: '22px' }}
                >
                    Please sign-in to your account
                </Typography>
            </Stack>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack
                    sx={{
                        // minWidth: '900px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        px: 2
                    }}
                >
                    <Box sx={{
                        justifyContent: 'space-between', width: '100%', maxWidth: '350px', mt: 2
                    }}
                    >
                        <FormControl fullWidth>
                            {/* <FormLabel htmlFor="email">Email</FormLabel> */}
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Username
                            </Typography>
                            <TextField
                                id="email"
                                type="text"
                                name="email"
                                placeholder="your@email.com"
                                autoComplete="off"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                sx={{
                                    ariaLabel: 'email', mb: 3, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                defaultValue={""}
                                {...register('email', { required: true })}
                                error={Boolean(errors.email)}
                                helperText={errors.email ? errors.email.message : ""}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Password
                            </Typography>
                            <TextField
                                name="password"
                                placeholder="••••••"
                                // type="password"
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                autoComplete="off"
                                fullWidth
                                variant="outlined"
                                {...register('password', { required: true })}
                                error={Boolean(errors.password)}
                                helperText={errors.password ? errors.password.message : ""}
                                sx={{
                                    mb: 2, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    height: '24px'
                                                }}
                                                onClick={handleTogglePassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </FormControl>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center', // Align items vertically in the center
                                mb: 4,
                                // Add margin-bottom for spacing
                            }}
                        >
                            <Link
                                to={"/account/register"}
                                variant="body2"
                                sx={{
                                    alignSelf: 'center', cursor: 'pointer', fontFamily: 'Poppins, Arial, sans-serif',

                                    textDecoration: 'none',
                                    fontWeight: 500,
                                }}
                            >
                                Sign up
                            </Link>
                            <Link
                                to={"/account/forgot_password"}
                                variant="body2"
                                sx={{
                                    alignSelf: 'center', cursor: 'pointer', fontFamily: 'Poppins, Arial, sans-serif',
                                    textDecoration: 'none',
                                    fontWeight: 500,
                                }}
                            >
                                Forgot your password?
                            </Link>


                        </Box>
                        {(screenSize.width < 1360) &&
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center', // Align items vertically in the center
                                alignContent: 'justify',
                                mb: 4,
                                width: '100%'
                                // Add margin-bottom for spacing
                            }}
                        ><Typography sx={{width: '100%', fontSize: '10px', color: 'red', alignContent: 'justify',}}>
                            Note: Your screen resolution is too small. Please increase it to at least 1360 x 768 for optimal viewing. Recommended screen resolution is 1920 x 1080.
                        </Typography>
                        </Box>
                        }
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            endIcon={<ArrowForwardOutlined />}
                            sx={{
                                borderRadius: '16px', width: '100%', textTransform: 'uppercase',
                                fontWeight: '500', fontSize: '18px', maxWidth: '350px',
                            }}
                        >
                            Login
                        </Button>
                    </Box>
                </Stack>
            </form>
        </Stack>
    )
}